module.exports = __webpack_public_path__ + "static/media/climate_workplace_2_manufacturingSites.9e5bf227.jpg";